import axios from 'axios'
import mixin  from '@/mixins/mixin';

/**
 * Per accedere globalmente a questo modulo usare rootState, rootGetters negli altri moduli
 * 
 * Esempio:
 * getters: {
 *  getRoute(state, getters, rootState) {
 *    return rootState.route;
 *   }
 * }
 */

export default {
	namespaced: true,
	
	state: {
		isLoading: false,
		fasiWithStati: [],
		strutturaDatiPratica: {},
		statiColorMap: {},
		fasiDelBandoAttivo: {}
	},

	getters: {
		isLoading(state) {
			return state.isLoading;
		},
		fasiWithStati(state) {
			return state.fasiWithStati;
		},
		strutturaDatiPratica(state) {
			return state.strutturaDatiPratica;
		},
		statiColorMap(state) {
			return state.statiColorMap;
		},
		fasiDelBandoAttivo(state) {
			return state.fasiDelBandoAttivo;
		},
	},

	mutations: { // è il setter dello store, è sincrona, quindi meglio non usarla per fare chiamate api
		SET_IS_LOADING (state, value) {
			state.isLoading = value
		},
		SET_FASI_WITH_STATI (state, value) {
			state.fasiWithStati = value
		},
		SET_STRUTTURA_DATI_PRATICA (state, payload) {
			const nomeStrutturaDati = `strutturaDatiPraticaBando${payload.bandoId}`
			state.strutturaDatiPratica = Object.assign({}, mixin.data()[nomeStrutturaDati]);
			
			for (const key in state.strutturaDatiPratica.fasi) {
				state.strutturaDatiPratica.fasi[key].stati = payload.fasiWithStati.find(fase => fase.ordinamento == key)?.stati;
			}
		},
		SET_STATI_COLOR_MAP (state, map) {
			state.statiColorMap = map
		},
		SET_FASI_DEL_BANDO_ATTIVO (state, value) {
			state.fasiDelBandoAttivo = value;
		}
	},

	actions: { // sono asincrone, posso fare chiamate api e richiamare poi la mutation
		getFasiWithStati({ commit, rootGetters }) { // Chiamata al login o al logout
			commit('SET_IS_LOADING', true);
			return axios.get('/api/fasi/with-stati')
				.then(response => {
					let fasiWithStati = response.data;
					
					// serve per la guida (vue tour)
					// .tour-step-22 è il target dello step da cui si cliccherà sui tab
					// nella variabile startTargetNumber indico il numero della step da cui si può cliccare sulla tab
					// gli steps si trovano in tour.module.js
					let startTargetNumber = 22;
					for (const key in fasiWithStati) {
						// nella fase 1 non si clicca sulla tab
						if (fasiWithStati[key].ordinamento == 1) continue
						// TODO: settare la classe specifica per gli step in cui si clicca sulle fasi, per esempio tour-step-pratica-inail-click
						fasiWithStati[key].stepTargetClass = `tour-step-${startTargetNumber}`;
						startTargetNumber++;
					}
					
					commit('SET_FASI_WITH_STATI', fasiWithStati);
					commit('SET_STRUTTURA_DATI_PRATICA', {
						fasiWithStati: fasiWithStati,
						bandoId: rootGetters['shared/bando'].id
					})
					
					const statiColorMap = Object.freeze(
						Object.fromEntries(
							fasiWithStati.flatMap(f => f.stati.map(s => [s.id, s.codice_colore]))
						)
					)
					commit('SET_STATI_COLOR_MAP', Object.freeze(statiColorMap))   // non reattivo
					
					const fasiDelBandoAttivo = new Set(response.data.map(f => f.ordinamento))
					commit('SET_FASI_DEL_BANDO_ATTIVO', fasiDelBandoAttivo)
				})
				.finally(() => {
					commit('SET_IS_LOADING', false);
				})
		},
	}
}

// export default {
// 	namespaced: true,
// 	state,
// 	getters,
// 	mutations,
// 	actions
// }